var exports = {
  "I": "commentBody___sP2XK",
};

module.exports = exports;
